import { render, staticRenderFns } from "./itemSubGroup.vue?vue&type=template&id=5b3be2ae"
import script from "./itemSubGroup.vue?vue&type=script&lang=js"
export * from "./itemSubGroup.vue?vue&type=script&lang=js"
import style0 from "./itemSubGroup.vue?vue&type=style&index=0&id=5b3be2ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports